var map = {
	"./acontroller_notselected.png": 2794,
	"./additional_controller_notselected.png": 8257,
	"./battery_notselected.png": 5069,
	"./bill_notselected.png": 9593,
	"./box_notselected.png": 4103,
	"./button_notselected.png": 302,
	"./cameraglass_notselected.png": 5024,
	"./cd_notselected.png": 909,
	"./charger_notselected.png": 2093,
	"./chargingport_notselected.png": 6405,
	"./controller_notselected.png": 6433,
	"./fingertouch_notselected.png": 9885,
	"./frontcamera_notselected.png": 4052,
	"./hdmi_notselected.png": 6795,
	"./keyboard_notselected.png": 7783,
	"./lan_notselected.png": 7262,
	"./microphone_notselected.png": 5837,
	"./mouse_notselected.png": 3375,
	"./original_controllers_notselected.png": 4154,
	"./powerbutton_notselected.png": 6403,
	"./proximitysensor_notselected.png": 2880,
	"./rearcamera_notselected.png": 4646,
	"./remote_notselected.png": 8200,
	"./simcard_notselected.png": 296,
	"./speaker_notselected.png": 8718,
	"./speakerbutton_notselected.png": 5923,
	"./touchpad_notselected.png": 8618,
	"./trackpad_notselected.png": 4441,
	"./usb_notselected.png": 5165,
	"./vibrator_notselected.png": 9079,
	"./volume_notselected.png": 5147,
	"./webcamera_notselected.png": 4816,
	"./wifibluetooth_notselected.png": 9378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2769;